export const casLinks = {
  referAndWin:
    "https://nuvamawealth.com/cas/microsite/nuvama-trade-mate/?utm_source=invitereferrals-referrer&utm_campaign=footer&utm_medium=website",
  investorCharterDepositoryParticipant:
    "https://nuvamawealth.com/cas/landing-pages/nuvama-investor-charter/nuvama-investor-charter-depository-participant.html",
  investorCharterStockBrokers:
    "https://nuvamawealth.com/cas/Landing-pages/Nuvama-Investor-Charter/Nuvama-Investor-Charter-Stock-Brokers.html",
  regulatoryUpdates:
    "https://nuvamawealth.com/cas/microsite/Nuvama-Regulatory-Processes/index.html",
  smallcase:
    "https://smallcases.nuvamawealth.com/?26utm_source=nuvamawealth&utm_medium=website&utm_campaign=homepage&utm_content=guided-investing",
  investorCompliance:
    "https://www.nuvamawealth.com/ewwebimages/webFiles/disclaimer/Complaints.pdf",
  sebiscore: "https://scores.sebi.gov.in/",

  getstartedlink: "https://onboarding.nuvamawealth.com/",
  getstartedlinkStatus: "https://onboarding.nuvamawealth.com/status",
  odr: "https://smartodr.in/login",
  webinar:
    "https://www.nuvamawealth.com/cas/microsite/Nuvama-Webinar-Recordings-1/index.html",
  partnerWithUs: "https://www.nuvamawealth.com/partner-with-us",
  downloadnuvamaApp:
    "https://www.nuvamawealth.com/nuvama-markets-share-market-live-trading-app",
  investorcharter:
    "https://www.nuvamawealth.com/cas/Landing-pages/Nuvama-Investor-Charter/Nuvama-Investor-Charter-In-Respect-of-RAs.html",

  NSEWebsite: "https://www.nseindia.com/",
  BSEWebsite: "https://www.bseindia.com/",

  nuvamaWealth: "https://www.nuvama.com/",
  wealthManagement: "https://www.nuvama.com/our-businesses/wealth-management/",
  assetManagement: "https://www.nuvama.com/our-businesses/asset-management/",
  capitalMarkets: "https://www.nuvama.com/our-businesses/capital-markets/",
  invetorEducation: "https://www.bseipf.com/investors_education.html",
  appStore:
    "https://apps.apple.com/in/app/nuvama-live-share-trading-app/id1031657545?mt=8",
  googlePlay:
    "https://play.google.com/store/apps/details?id=com.msf.emt.mobile&referrer=af_tranid%3DiBiebwtPc8IaDUm8XO8Ucg%26pid%3DnewEW",
};

export const footerLinks = {
  AboutUs: "/aboutus",
};
